import React, { useState, useEffect } from "react";
import { useLanguageContext } from "../../../Context/LanguageContext";
import { useEqGRpListContext } from "../../../Context/GlobalContext";
import InputFieldControl from "../../ReusableComponent/InputFieldControl";
import { _helper } from "../../GlobalFunction/dateHelper";
import { GrPowerReset } from "react-icons/gr";
import equipmentGroupActions from "../../../Actions/EquipmentGroupActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import equipmentGroupStore from "../../../Stores/EquipmentGroupStore";
import equipmentGroupConstants from "../../../Constants/EquipmentGroupConstants";
import MultiSelectCheckbox from "../../ReusableComponent/MultiSelectCheckbox";

export default function EmailHeader({
  fieldValues,
  setFieldValues,
  setIsFilterVisible,
  setRenderFilterList,
  setFilterList,
  setFilterValue,
  filterList,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  // const eqGrpList = useEqGRpListContext();
  const [eqGrpList, setEqGrpList] = useState([]);
  const [fields, setFields] = useState(fieldValues);
  const [minDate, setMinDate] = useState();
  const [startDate, setStartDate] = useState(_helper.defaultDate(0));

  useEffect(() => {
    setFields(fieldValues);
  }, [fieldValues]);

  useEffect(() => {
    function updateEquipmentGroup() {
      setGlobalSpinner(false);
      var res = equipmentGroupStore.getEquipmentGroupList();
      setEqGrpList(res);
    }
    equipmentGroupStore.addChangeListener(
      equipmentGroupConstants.GET_EQUIPMENTGROUP_SUCCESS,
      updateEquipmentGroup
    );
    return () => {
      equipmentGroupStore.removeChangeListener(
        equipmentGroupConstants.GET_EQUIPMENTGROUP_SUCCESS,
        updateEquipmentGroup
      );
    };
  }, []);

  function handleFieldValueChanges(event) {
    event.preventDefault();
    const { name, value } = event.target;

    setFieldValues((prevFieldValues) => ({
      ...prevFieldValues,
      [name]:
        name === "title"
          ? fieldValues[name] !== ""
            ? value
            : value.trim()
          : value,
    }));
  }

  function handleDateChange(_value, _index, _name) {
    if (_name === "startDate") {
      setMinDate(_value);
      if (fields["endDate"] !== "") {
        setFieldValues((prevFieldValues) => ({
          ...prevFieldValues,
          ["endDate"]: "",
        }));
      }
    }
    const _date = _helper.dateFormate(_value);
    setFieldValues((prevFieldValues) => ({
      ...prevFieldValues,
      [_name]: _date,
    }));
  }

  function RenderReset(row, pos) {
    return (
      <>
        <GrPowerReset
          className="cursorPoint svgIcon ml-2 emailheadBttReset"
          size={20}
          title={localization.reset}
          onClick={(e) => {
            e.preventDefault();
            setFieldValues((previous) => ({
              ...previous,
              ["endDate"]: "",
            }));
          }}
        />
      </>
    );
  }
  return (
    <div className="row">
      <div className="col">
        <div className="form-group">
          <label htmlFor="groupName">{localization.subject}</label>
          <input
            required
            className="form-control"
            name="title"
            value={fields.title}
            onChange={handleFieldValueChanges}
          />
        </div>
        <div className="form-group">
          <label htmlFor="eqgrpSelected">
            {localization.equipmentGroupName}
          </label>

          <div className="d-flex w-100 ">
            <MultiSelectCheckbox
              name="eqgrpSelected"
              options={eqGrpList.map((item) => ({
                value: item.id,
                label: item.bezeichnungsDisplay,
              }))}
              selectedValues={fields.eqgrpSelected}
              onChange={(e) => {
                setRenderFilterList(null);
                setIsFilterVisible(false);
                setFilterList(null);
                handleFieldValueChanges(e);
              }}
              disabled={!eqGrpList.length > 0}
            />
          </div>
        </div>
      </div>
      <div className="col">
        <div className="form-group">
          <label htmlFor="emailType">{localization.emailType}</label>
          <select
            className="form-control"
            id="emailType"
            name="emailType"
            value={fields.emailType}
            onChange={handleFieldValueChanges}
          >
            <option value={"DueOrOverdueInspection"}>
              {localization.dueOverdueInspection}
            </option>
          </select>
        </div>
        <div className="row">
          <div className="col-6">
            <InputFieldControl
              name="startDate"
              type="datePicker"
              label={localization.startDate}
              selectedValue={fields.startDate}
              _onDateChange={handleDateChange}
              _index="1"
              isLabel={true}
              startDate={startDate}
              isDisable={false}
            />
          </div>
          <div className="col-6 d-flex">
            <InputFieldControl
              name="endDate"
              type="datePicker"
              label={localization.endDate}
              selectedValue={fields.endDate}
              _index="2"
              _onDateChange={handleDateChange}
              isLabel={true}
              startDate={minDate}
              isDisable={fields.startDate === "" ? true : false}
            />
            <RenderReset />
          </div>
        </div>
      </div>
    </div>
  );
}
